import React from "react";
import AnimatedElement from "../AnimatedElement";
import img1carrousel from "../../assets/images/Servicios/img1carrousel.png";
import img2carrousel from "../../assets/images/Servicios/img2coarrousel.jpg";
import img3carrousel from "../../assets/images/Servicios/imagecarros.png";
import imgservices from "../../assets/images/Servicios/imgservices.png";
import imgsupport from "../../assets/images/Servicios/collage_soluciones.png";
import imgCajero2 from "../../assets/images/Servicios/img-servicio-men.JPG";
import { useTranslation } from "react-i18next";
import "../../i18next";
import { Link } from "react-router-dom";

function SeccionServicios() {
  const { t } = useTranslation();

  const dataArray = [
    "item1",
    "item2",
    "item3",
    "item4",
    "item5",
    "item6",
    "item7",
    "item8",
    "item9",
    "item10",
    "item11",
    "item12",
  ];

  const listedItems = dataArray.map((item, index) => (
    <li
      key={index}
      className="font-bold text-fontWhite text-sm md:text-2xl border-b-2 py-2 list-item"
    >
      {t(`servicios.${item}`)}
    </li>
  ));

  return (
    <>
      {/* Título principal */}
      <section className="px-4 pt-12 md:pt-16">
        <h1 className="text-orangeAtm font-bold text-4xl md:text-8xl mb-2">
          {t("servicios.title")}
        </h1>
        <hr className="border-t-2 border-orangeAtm my-4" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <h2 className="text-orangeAtm text-3xl md:text-5xl font-bold">
            {t("servicios.subtitle1")}
          </h2>
          <p className="text-darkBlueText text-base mb-4">
            {t("servicios.text1")}
          </p>
        </div>
      </section>

      {/* Imágenes destacadas */}
      <section className="bg-darkBlueText px-4 py-8 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[img1carrousel, img2carrousel, img3carrousel].map((img, i) => (
          <div key={i} className="bg-[#FF5408] p-4 rounded-[24px]">
            <AnimatedElement fromDirection={i % 2 === 0 ? "top" : "bottom"}>
              <img
                src={img}
                alt={`img${i}`}
                className="mx-auto mb-4  h-72 w-full object-cover rounded-md"
              />
              <p className="text-fontWhite text-sm md:text-base">
                {t(`servicios.textImg${i + 1}`)}
              </p>
            </AnimatedElement>
          </div>
        ))}
      </section>

      {/* Servicios principales */}
      <section className="px-4 py-12">
        <h2 className="text-orangeAtm text-4xl md:text-6xl font-medium mb-8">
          {t("servicios.services")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="space-y-8">
            {[2, 3, 4].map((i) => (
              <AnimatedElement key={i} fromDirection="left">
                <div className="border-l-4 border-orangeAtm pl-4">
                  <h4 className="text-darkBlueText font-bold text-lg md:text-3xl mb-2">
                    {t(`servicios.subtitle${i}`)}
                  </h4>
                  <p className="text-customDarkBlue text-sm md:text-lg">
                    {t(`servicios.text${i}`)}
                  </p>
                </div>
              </AnimatedElement>
            ))}
          </div>
          <div className="md:block hidden">
            <AnimatedElement fromDirection="bottom">
              <img
                src={imgCajero2}
                alt="ATM Services"
                className="w-full h-[600px] object-contain"
              />
            </AnimatedElement>
          </div>
        </div>
        {/* Imagen para móviles */}
        <div className="md:hidden mt-8">
          <AnimatedElement fromDirection="bottom">
            <img
              src={imgCajero2}
              alt="ATM Services"
              className="w-full h-auto"
            />
          </AnimatedElement>
        </div>
      </section>

      {/* Transformación y soluciones */}
      <section className="bg-[#19235c] text-white px-4 py-16 md:py-32">
        <AnimatedElement fromDirection="top">
          <h2 className="text-4xl md:text-6xl text-orangeAtm font-bold mb-6">
            {t("servicios.transforming")}
          </h2>
          <p className="text-base md:text-2xl mb-6">
            {t("servicios.textTransform")}
          </p>
          <Link
            to="/contactenos"
            className="bg-white text-customDarkBlue px-4 py-2 rounded hover:bg-orangeAtm hover:text-white transition"
          >
            {t("servicios.contactus")}
          </Link>
        </AnimatedElement>

        <AnimatedElement fromDirection="left" className="mt-16">
          <h2 className="text-4xl md:text-6xl text-orangeAtm font-medium mb-6">
            {t("servicios.solutions")}
          </h2>
        </AnimatedElement>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
          <div className="hidden md:block">
            <AnimatedElement fromDirection="left">
              <img
                src={imgsupport}
                alt="Process Integration"
                className="w-full h-auto"
              />
            </AnimatedElement>
          </div>
          <div>
            <AnimatedElement fromDirection="right">
              <ul className="list-disc pl-6 space-y-4 marker:text-orangeAtm">
                {listedItems}
              </ul>
            </AnimatedElement>
          </div>
        </div>
      </section>
    </>
  );
}

export default SeccionServicios;
